import { render } from "./CardHero.vue?vue&type=template&id=0f8b11c8"
import script from "./CardHero.vue?vue&type=script&lang=js"
export * from "./CardHero.vue?vue&type=script&lang=js"

import exportComponent from "/Users/perro/Documents/Repositorios/github/guaw/clicsocial/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.8_vue@3.5.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__